module.exports = __webpack_public_path__ + "static/media/bgr-news-block004.4e2992cb.svg";